import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ins-qualification',
  templateUrl: './ins-qualification.fragment.html',
  styleUrls: [
    './ins-qualification.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class InsQualificationFragment implements OnInit {

  public header: string = '';
  public msg: string = '';
  public list: string[] = [];
  
  public selectedDocument: string = '';
  public hideQualification: boolean = false;
  
  public documents: { value: string, label: string }[] = [];

  @Output() public closeEmitter = new EventEmitter<{ confirmed: boolean, documentSelected?: string }>();

  constructor() { }

  ngOnInit(): void {
  }

  public clickOuside(): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }
    this.closeModal();
  }

  public closeModal(): void {
    this.closeEmitter.emit({ confirmed: false });
  }

  public confirmAction() {
    this.closeEmitter.emit({ confirmed: true, documentSelected: this.selectedDocument });
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
